var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('breadcrumb',{attrs:{"menu":[
      { title: _vm.$t('erp.inventory.title'), routeName: '' },
      {
        title: _vm.$t('erp.inventory.products.title'),
        routeName: 'erp.inventory.products'
      }
    ]}}),_c('div',{staticClass:"pt-2 space-y-2 mx-auto px-4 sm:px-6 lg:px-8"},[_c('ProductsTable',{ref:"productsTable",attrs:{"withImageResolution":1}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }